module.exports = __webpack_public_path__ + "img/13.56605bb5.png";